var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCodecksIconCompact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#383A42",
    fillRule: "evenodd",
    d: "M22.86 21.1c-1.36 1.84-3.28 2.55-6 1.95-2.7-.61-4.09-2.84-3.96-5.56.15-3.53 3.03-5.52 6.23-5a6 6 0 0 1 4.25 2.97l12.22-4.72C30.13-2.63 10.42-4.02 2.83 9.41c-6.25 11.06.8 24.28 12.48 26.3 8.93 1.54 17.26-3.2 20.29-11.05L22.86 21.1Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7BC0D6",
    d: "M10.42 8.03a12.84 12.84 0 0 0-5 8.8c-.28 2.55.2 8.46 6.45 12.33 5.9 3.64 14.82 1.36 17.9-5.09l3.9 1.32c-2.95 5.02-7.26 8.76-13.17 9.52-3.87.5-8.24-.5-11.44-2.64C2.03 27.55-.8 19 2.9 10.8 5.06 6 8.97 3.07 13.58 1.71c7.63-2.24 15.87 1.45 19.88 8.42-1.5.69-2.4 1.07-3.97 1.76a13.94 13.94 0 0 0-3.78-4.13c-5.13-3.66-11.39-2.66-15.28.26Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E50F3C",
    d: "M9.06 17.04a8.91 8.91 0 0 1 3.45-6.12c4.79-3.66 10.68-2.28 13.69 2.4l2.74-1.2c-3.15-4.96-8.49-7.18-14.04-5.66a11.95 11.95 0 0 0-7.76 6.57c-2.63 5.72-.44 11.58 4.53 15.23a12.36 12.36 0 0 0 17.4-4.44l-2.8-.93a9.37 9.37 0 0 1-6 4.2c-2.83.57-5.46-.4-7.02-1.33-4.25-3-4.38-6.93-4.19-8.72Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.58 13.03c-3.57 2.58-3.04 8.3.73 10.17 2.59 1.29 5.57 1.12 7.76-1.41l2.55.86c-1.54 2.06-3.32 3.56-6.33 3.87a8.61 8.61 0 0 1-8.87-12.1c1.1-2.34 3.1-3.68 5.65-4.6 3.99-1.03 7.49.78 9.54 3.81l-2.05.94a6.3 6.3 0 0 0-8.98-1.54Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodecksIconCompact);
export default __webpack_public_path__ + "static/media/codecks-icon-compact.58bb4b0f19ca3c35809bf7742d35f88d.svg";
export { ForwardRef as ReactComponent };